export const compactNumber = (number: number) => {
  return new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    roundingPriority: 'lessPrecision',
    maximumFractionDigits: 2,
  }).format(number);
};
